export default __webpack_public_path__ + "static/media/about-img.536ad19b.png";